import { createGlobalStyle } from "styled-components"
import "../assets/fonts/Sequel-Light.woff";

export const GlobalStyle = createGlobalStyle`
  body { 
    margin: 0;
    font-size: 100%;
      max-width: 1920px;
  position:relative;
    margin:0 auto;
  }
  body * {
    box-sizing: border-box;
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
      font-variant-ligatures: none;

    color: #55585A;
    
  } 
  h1, h2, h3,h4,h5,h6,p, li, a, span, legend, label, option, select, input {
    margin: 0;
  }

  a {
    color: #161065;
  }
  .ReactModal__Overlay {
    background-color: rgba(0,0,0,0.7) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000;
  }
  .ReactModal__Content {
    max-width: 600px;
    min-width: 30vw;
    position: static !important;
  }
  .ReactModal__Body--open {
    overflow: hidden;
  }

  @keyframes spinning {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }


  @media print {
    body {
      color: black;
      background: white;
    }
  }


`

export const theme = {
  lightBlue: "#eef9fe",
  midBlue: "#4A50E2",
  darkBlue: "#2a61c1",
  lightGreen: "#b6cf3c",
  brightGreen: "#B6D237",
  darkGreen: "#006239",
  lightGreen: "#EEFEF7",
  midGreen: "#4AE2D8",
  white: "#ffffff",
  darkGrey: "#55585A",
  lightGrey: "#f2f4f4",
  midGrey: "#7081A1",
  blueGrey: "#E4E8EE",
  red: "#ff5b5b",

  fontSizeXSmall: "0.7em",
  fontSizeSmall: "0.85em",
  fontSizeBase: "1em",
  fontSizeMedium: "1.2em",
  fontSizeLarge: "1.6em",
  fontSizeXLarge: "1.8em",
  fontSizeXXLarge: "3.4em",

  fontWeightBold: 600,
  fontWeightBase: 400,
  fontWeightLight: 300,

  inputHeight: "2.2em",
}
